import { OPTIONS_EVENT } from "../../app/gameConfig.ts";
import { useT } from "../../gamzone/i18n.ts";

/**
 * The ⚙ corner button shown on every non-match campaign screen (map,
 * dialogue, subtitles/bridges, ending) — MatchScreen has its own on-canvas
 * pause button, but nothing else did, so there was no way to reach Settings
 * without going through the sidebar. Fires `OPTIONS_EVENT`; App.tsx listens
 * and opens the same Settings modal as the sidebar's account button.
 * `stopPropagation` keeps a tap here from also advancing whatever
 * tap-to-continue screen it sits on top of (Subtitles/Ending/ActMap all
 * treat a click anywhere as "next").
 */
export function OptionsButton() {
  const t = useT();
  return (
    <button
      type="button"
      className="cam-options-btn"
      aria-label={t("settings")}
      onClick={(e) => {
        e.stopPropagation();
        window.dispatchEvent(new Event(OPTIONS_EVENT));
      }}
    >
      <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
        <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.5.5 0 0 0 .12-.61l-1.92-3.32a.5.5 0 0 0-.59-.22l-2.39.96a7.3 7.3 0 0 0-1.62-.94L14.4 2.81a.49.49 0 0 0-.48-.41h-3.84a.49.49 0 0 0-.47.41L9.25 5.35c-.59.24-1.13.57-1.62.94l-2.39-.96a.5.5 0 0 0-.59.22L2.74 8.87a.5.5 0 0 0 .12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.5.5 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32a.5.5 0 0 0-.12-.61l-2.03-1.58ZM12 15.6a3.6 3.6 0 1 1 0-7.2 3.6 3.6 0 0 1 0 7.2Z" />
      </svg>
    </button>
  );
}
